import React from 'react';
import Icon from '../../../components/AppIcon';

const AchievementBadge = ({ achievement }) => {
  return (
    <div className={`bg-card border rounded-lg p-4 transition-smooth ${
      achievement?.unlocked
        ? 'border-accent/50 bg-accent/5 hover:shadow-elevation-2'
        : 'border-border opacity-50'
    }`}>
      <div className="flex items-start gap-3">
        <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
          achievement?.unlocked
            ? 'bg-accent/20 text-accent' :'bg-muted/20 text-muted-foreground'
        }`}>
          <Icon name={achievement?.icon} size={24} />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="font-semibold text-foreground">
              {achievement?.title}
            </h4>
            {achievement?.unlocked && (
              <Icon name="CheckCircle2" size={16} className="text-accent" />
            )}
          </div>
          <p className="text-sm text-muted-foreground">
            {achievement?.description}
          </p>
          {achievement?.unlocked && (
            <span className="inline-block mt-2 px-2 py-0.5 bg-accent/20 text-accent text-xs font-medium rounded">
              Unlocked
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default AchievementBadge;